import app from 'flarum/forum/app';
export const supportsWebPush = () => 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
export const getVapidPublicKey = () => app.forum.attribute('vapidPublicKey');
export function getApplicationServerKey(subscription) {
  const key = subscription.options.applicationServerKey;
  if (!key) return undefined;
  return btoa(String.fromCharCode(...new Uint8Array(key))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
export const pushConfigured = () => Boolean(getVapidPublicKey());
export const hasEnabledPushPreference = () => {
  const preferences = app.session.user?.preferences();
  if (!preferences) return false;
  return Object.entries(preferences).some(([key, enabled]) => key.startsWith('notify_') && key.endsWith('_push') && enabled === true);
};
flarum.reg.add('fof-pwa', 'forum/push/utils', { supportsWebPush: supportsWebPush,getVapidPublicKey: getVapidPublicKey,getApplicationServerKey: getApplicationServerKey,pushConfigured: pushConfigured,hasEnabledPushPreference: hasEnabledPushPreference, });